import React from 'react';
import { Box } from '@mui/material';

/**
 * קומפוננטת עזר להצגת תצוגה מקדימה של ווידג'טים
 * מציגה את הווידג'ט בגודל מוקטן עם נתוני דמה
 */
const WidgetPreview = ({ children, scale = 0.25 }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#f8fafc',
                borderRadius: 1.5,
                position: 'relative',
            }}
        >
            {scale === 1 ? (
                // אם scale=1, פשוט מציג את הילד ללא טרנספורמציה
                <Box
                    sx={{
                        width: '100%',
                        height: '100%'
                    }}
                >
                    {children}
                </Box>
            ) : (
                <Box
                    sx={{
                        transform: `scale(${scale})`,
                        transformOrigin: 'center center',
                        width: `${100 / scale}%`,
                        height: `${100 / scale}%`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
};

export default WidgetPreview;
